import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft, Mail } from "lucide-react";

const CONTACT_EMAIL = "info@tweakmycreditreport.com";

function LegalHeader() {
  return (
    <header className="tk-header sticky top-0 z-50" data-testid="legal-header">
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-brand-link">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center"
               style={{ background: "linear-gradient(135deg,#14B8A6,#0d9488)" }}>
            <ShieldCheck className="w-5 h-5 text-[#020813]" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-white text-base md:text-lg tracking-tight">
            tweakmycreditreport<span className="text-[#14B8A6]">.com</span>
          </span>
        </Link>
        <Link
          to="/"
          className="btn-ghost px-4 py-2 rounded-lg text-xs font-semibold inline-flex items-center gap-2"
          data-testid="legal-back-home"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Back to home
        </Link>
      </div>
    </header>
  );
}

function LegalFooter() {
  return (
    <footer className="border-t border-[#14B8A6]/10" style={{ background: "#01040A" }}>
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#64748B]">
        <span>© {new Date().getFullYear()} tweakmycreditreport.com — All rights reserved.</span>
        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-5">
          <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white transition-colors">{CONTACT_EMAIL}</a>
          <span className="hidden md:inline text-[#334155]">·</span>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function LegalPage({ title, subtitle, updated, children, testid }) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--tk-bg)" }} data-testid={testid}>
      <LegalHeader />
      <main className="flex-1">
        <section className="relative overflow-hidden border-b border-[#14B8A6]/10">
          <div className="absolute inset-0 hero-glow pointer-events-none opacity-60" />
          <div className="relative max-w-4xl mx-auto px-6 md:px-10 pt-14 md:pt-20 pb-10 md:pb-14">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#14B8A6]">
              Legal
            </span>
            <h1 className="font-display mt-3 text-4xl md:text-5xl font-black tracking-tighter text-white leading-tight">
              {title}
            </h1>
            {subtitle ? (
              <p className="mt-4 text-[#94A3B8] leading-relaxed max-w-2xl">{subtitle}</p>
            ) : null}
            {updated ? (
              <p className="mt-5 text-xs text-[#64748B] uppercase tracking-wider">
                Last updated · {updated}
              </p>
            ) : null}
          </div>
        </section>

        <section className="relative">
          <div className="max-w-4xl mx-auto px-6 md:px-10 py-14 md:py-20">
            <article className="legal-prose">{children}</article>

            <div className="mt-14 pt-8 border-t border-[#14B8A6]/10 flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#14B8A6]" />
              <span className="text-sm text-[#94A3B8]">
                Questions? Reach us at{" "}
                <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#14B8A6] hover:underline">
                  {CONTACT_EMAIL}
                </a>
              </span>
            </div>
          </div>
        </section>
      </main>
      <LegalFooter />
    </div>
  );
}
